"use client"

import Link from "next/link"
import Image from "next/image"
import { socialMedia } from "@/data"
import { useTranslations } from "next-intl"

export function SiteFooter() {
  const t = useTranslations("footer")
  const tNav = useTranslations("navigation")
  
  return (
    <footer className="py-16 border-t border-border/50">
      <div className="grid md:grid-cols-3 gap-12 mb-12">
        {/* Brand */}
        <div className="md:col-span-1">
          <Link href="/" className="inline-block mb-4">
            <Image 
              src="/holistika-short-100x100.svg" 
              alt="Holistika" 
              width={48} 
              height={48}
              className="opacity-80 hover:opacity-100 transition-opacity"
            />
          </Link>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {t("tagline")}
          </p>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="text-foreground font-semibold mb-4">{t("company")}</h4>
          <ul className="space-y-3">
            <li>
              <Link href="/vision" className="text-muted-foreground text-sm hover:text-foreground transition-colors">
                {tNav("vision")}
              </Link>
            </li>
            <li>
              <Link href="/manifiesto" className="text-muted-foreground text-sm hover:text-foreground transition-colors">
                {tNav("manifiesto")}
              </Link>
            </li>
            <li>
              <Link href="/tech-lab" className="text-muted-foreground text-sm hover:text-foreground transition-colors">
                {tNav("techLab")}
              </Link>
            </li>
            <li>
              <Link href="/contact" className="text-muted-foreground text-sm hover:text-foreground transition-colors">
                {tNav("contact")}
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-foreground font-semibold mb-4">{t("legal")}</h4>
          <ul className="space-y-3">
            <li>
              <Link href="/privacy" className="text-muted-foreground text-sm hover:text-foreground transition-colors">
                {t("privacy")}
              </Link>
            </li>
            <li>
              <Link href="/terms" className="text-muted-foreground text-sm hover:text-foreground transition-colors">
                {t("terms")}
              </Link>
            </li>
            <li>
              <Link href="/cookies" className="text-muted-foreground text-sm hover:text-foreground transition-colors">
                {t("cookies")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Trademarks notice — Branded House posture per BRAND_HIERARCHY_AND_TRADEMARK_SCOPE_2026-04 */}
      <div className="pt-8 border-t border-border/30 mb-6">
        <h4 className="text-foreground/70 font-semibold text-xs uppercase tracking-wider mb-2">
          {t("trademarksTitle")}
        </h4>
        <p className="text-muted-foreground/60 text-xs leading-relaxed max-w-4xl">
          {t("trademarksNotice")}
        </p>
      </div>

      {/* Bottom bar — Spanish LSSI-CE Article 10 legal disclosure */}
      <div className="flex flex-col md:flex-row justify-between items-start gap-4 pt-6 border-t border-border/30">
        <div className="flex flex-col gap-1">
          <p className="text-muted-foreground/70 text-sm">
            &copy; {new Date().getFullYear()} {t("legalEntity")}. {t("rights")}
          </p>
          <p className="text-muted-foreground/50 text-xs">
            {t("legalEntityDisclosure")}
          </p>
        </div>

        <div className="flex items-center gap-4 mt-2 md:mt-0">
          {socialMedia.map((social) => (
            <a
              key={social.id}
              href={social.url || "#"}
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-card border border-border hover:border-accent-primary/50 transition-colors"
            >
              <Image 
                src={social.img} 
                alt="Social" 
                width={18} 
                height={18}
                className="opacity-60 hover:opacity-100 transition-opacity"
              />
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}
